export const LoadingScreen = () => (
  <div className="flex items-center justify-center h-full w-full bg-background">
    <div className="w-10 h-10 rounded-full border-4 border-primary-light border-t-primary animate-spin" />
  </div>
)
